import React from "react";
import PropTypes from "prop-types";

import { Icon, ICONS } from "../Icons";
import {
  ErrorAlert,
  IconContainer,
  ErrorMessage,
  ErrorReason,
  ErrorDescription,
  CloseIconWrapper,
  StyledCloseIcon
} from "./styled";

/**
 * Notification component for displaying alerts and error messages
 *
 * @component
 */
export const Notification = ({
  onClose,
  icon = ICONS.lock,
  title = "Oops!",
  message = "We are facing a glitch at the moment, please try again later.",
  status = "",
  stakTrace = ""
}) => {
  return (
    <ErrorAlert>
      <IconContainer>
        <Icon name={icon} />
      </IconContainer>

      <ErrorMessage>
        <ErrorReason>{title}</ErrorReason>
        <ErrorDescription>{message}</ErrorDescription>
        {status && <ErrorDescription>{status}</ErrorDescription>}
        {stakTrace && <ErrorDescription>{stakTrace}</ErrorDescription>}
      </ErrorMessage>

      <CloseIconWrapper>
        <StyledCloseIcon>
          <Icon name={ICONS.close} onClick={onClose} />
        </StyledCloseIcon>
      </CloseIconWrapper>
    </ErrorAlert>
  );
};

Notification.propTypes = {
  /** Function to handle closing the notification */
  onClose: PropTypes.func.isRequired,
  /** Icon to display in the notification */
  icon: PropTypes.string,
  /** Title of the notification */
  title: PropTypes.string,
  /** Main message to display */
  message: PropTypes.string,
  /** Status information (optional) */
  status: PropTypes.string,
  /** Stack trace information for debugging (optional) */
  stakTrace: PropTypes.string
};
